import murmurhash from 'murmurhash'

const sortObjectKeys = (obj: any): any => {
  if (!obj || typeof obj !== 'object') return obj
  if (Array.isArray(obj)) return obj.map(sortObjectKeys)

  return Object.keys(obj)
    .sort()
    .reduce((result: any, key) => {
      result[key] = sortObjectKeys(obj[key])
      return result
    }, {})
}

export interface HashableIndicator {
  name: string
  params?: Record<string, unknown> | null
}

/**
 * Platform-canonical indicator instance identity. Must stay byte-identical to
 * pattern-detection-service's TradingPlanManager.createConditionHashes and the
 * charting engine's IndicatorCalculator.getHash: falsy params are dropped
 * before hashing the key-sorted {name, params} JSON. Unlike those reference
 * implementations, this clones first — it must never mutate a live pattern.
 */
export const getIndicatorHash = (indicator: HashableIndicator): string => {
  const clone: HashableIndicator = { name: indicator.name }
  if (indicator.params) clone.params = indicator.params
  return murmurhash.v3(JSON.stringify(sortObjectKeys(clone))).toString()
}
